import * as React from "react";
import { createRoot } from 'react-dom/client';

import NotificationProvider from "./notification/NotificationProvider";
import Notification from "./notification/Notification";
import App from "./App";

const entryElement = document.getElementById("wishlist-app");

if(entryElement) {
	const root = createRoot(entryElement);
	root.render(
		<NotificationProvider>
			<App />
			<Notification />
		</NotificationProvider>
	);
}
